<template>
  <div class="bg_color">
    <top-header
      :type="6"
      :placeholder="'项目列表'"
      :hasBorder="true"
      :bgColor="'#fff'"
      fontSize="0.32rem"
    />
    <img src="@/assets/img/strictSelection/item.png" alt="" />
    <div class="middle">
      <div class="m_flex_box flex_vc flex_jz flex_hw">
        <div
          class="inner m_flex_box flex_jz"
          v-for="(item, index) in list"
          :key="index"
          @click="gotoPage(item.itemId, item.id)"
        >
          <div class="left">
            <img :src="'https://mjhx.xzhouse.com.cn/' + item.url" alt="" />
          </div>
          <div class="right">
            <div class="name">
              {{ item.itemName }}
            </div>
            <div style="color: #aaa;">备案名称：{{ item.regName }}</div>
            <div
              class="m_flex_box flex_vc"
              style="width: 4.25rem;color: #aaa;font-size: 0.26rem;"
            >
              <van-icon name="location-o" />
              <p class="line_comp1">
                {{ item.itemSite }}
              </p>
            </div>
            <div class="m_flex_box flex_vc icon_con">
              <span>{{ item.decoration }}</span>
              <span v-for="(item1, index1) in 1" :key="index1">
                {{ item.featureList[item1] }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topHeader from "@/components/header";
import "swiper/swiper-bundle.css";
export default {
  data() {
    return {
      list: [],
      id: this.$route.query.id,
      textColor: "#fff",
      bgColor: "transparent",
    };
  },
  components: {
    topHeader,
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.$request_yx
        .post("oldnew/itemInfo/list", { corpId: this.id })
        .then((res) => {
          if (res.success) {
            for (var i = 0; i < res.result.length; i++) {
              var item = res.result[i];
              if (res.result[i].feature) {
                item.featureList = res.result[i].feature.split(" ");
              } else {
                item.featureList = [];
              }
              if (item.itemName != "万科潮鸣") {
                this.list.push(item);
              }
            }
            console.log(this.list);
          } else {
            this.$toast(res.message);
          }
        });
    },
    gotoPage(itemId, id) {
      this.$router.push({
        path: "/strictSelectionItemDetail",
        query: {
          itemId: itemId,
          id,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bg_color {
  background-color: #fff;
  min-height: 100vh;
  img {
    width: 100%;
  }
  .middle {
    padding: 0.3rem 0.2rem;
    background: #fff;
    .inner {
      width: 100%;
      border-bottom: 1px solid #f5f5f5;
      padding: 0.25rem 0.1rem;
      font-size: 0.32rem;
      .left {
        img {
          width: 2.44rem;
          height: 1.84rem;
        }
      }
      .right {
        width: 4.25rem;
        font-size: 0.28rem;
        .name {
          font-size: 0.34rem;
          font-weight: bold;
        }
        div {
          margin-top: 5px;
        }

        .icon_con {
          span {
            padding: 0.04rem 0.06rem;
            color: #6c6d71;
            font-size: 0.22rem;
            background-color: #eef1f6;
            border-radius: 0.04rem;
            margin-right: 0.12rem;
          }
        }
      }
    }
  }
}
</style>
